import styled from 'styled-components';

export const ContainerLoader = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	height: 100vh;
`;
